// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yJ66b","colBig":"styles_colBig__3Ft1X","colSmall":"styles_colSmall__10Yr1"};